export enum EnvironmentsEnum {
  localdev = 'localdev',
  integration = 'integration',
  quality = 'quality',
  staging = 'staging',
  production = 'production',
}
